<div class="main-container-finance">
  <div class="page-header">
    <div class="breadcrumb">
      <a (click)="backToDashboard()" class="crumb crumb-link">Finance Dashboard</a>
      <span class="crumb-sep">/</span>
      <a (click)="backToFinanceDetails()" class="crumb crumb-link">Finance Details</a>
      <span class="crumb-sep">/</span>
      <span class="crumb crumb-current">Tier Rates</span>
    </div>

    <div class="page-actions">
      <button mat-flat-button color="primary" class="add-tier-rate-btn" type="button" (click)="openAdd()">
        <mat-icon>add</mat-icon>
        <span>Add Tier Rate</span>
      </button>
    </div>
  </div>

  <mat-card class="content-card">
    <div class="section-header">
      <div class="section-title">
        <span>Tier Rates</span>
      </div>
      <div class="section-actions">
        <mat-form-field appearance="outline" floatLabel="always" class="inline-filter">
          <mat-label>Year</mat-label>
          <mat-select
            [(value)]="selectedYear"
            (selectionChange)="onYearChange()"
            panelClass="finance-inline-filter-panel"
          >
            <mat-option *ngFor="let y of yearOptions" [value]="y">{{ y }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <ng-container *ngIf="loading">
      <ngx-skeleton-loader count="6" [theme]="{ height: '44px', 'margin-bottom': '4px' }"></ngx-skeleton-loader>
    </ng-container>

    <div *ngIf="errorMessage && !loading" class="error-state">{{ errorMessage }}</div>

    <ng-container *ngIf="!loading && !errorMessage">
      <div *ngIf="rows.length === 0" class="empty-state">
        No tier rates configured for {{ selectedYear }}. Use <strong>Add Tier Rate</strong> to seed the master.
      </div>

      <div *ngIf="rows.length > 0" class="table-wrap">
        <table mat-table [dataSource]="rows" [trackBy]="trackById" class="tier-rates-table">
          <ng-container matColumnDef="tierModel">
            <th mat-header-cell *matHeaderCellDef>Tier Model</th>
            <td mat-cell *matCellDef="let row">{{ row.tierModel }}</td>
          </ng-container>

          <ng-container matColumnDef="baseRate">
            <th mat-header-cell *matHeaderCellDef class="num">Base Rate</th>
            <td mat-cell *matCellDef="let row" class="num">
              <ng-container *ngIf="row.baseRate != null; else dashBase">
                {{ row.baseRate | currency : 'USD' : 'symbol' : '1.2-2' }}
              </ng-container>
              <ng-template #dashBase>—</ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions-col"></th>
            <td mat-cell *matCellDef="let row" class="actions-col">
              <button mat-icon-button matTooltip="Edit" (click)="openEdit(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Delete" (click)="delete(row)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </ng-container>
  </mat-card>
</div>
